import React, { Fragment, useState, useEffect } from "react";
import { Typography, Grid, Button, Box, makeStyles } from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { Link, useRouteMatch, useHistory } from "react-router-dom";
import sentierBackground from "../../images/sentierBackground.jpg";
import sentiersvg from "../../images/pictos-ok/SENTIER.svg";
import SERVICES_PRO_DU_RANDONNEURsvg from "../../images/pictos-ok/SERVICES PRO DU RANDONNEUR.svg";
import FREQUENTATIONsvg from "../../images/pictos-ok/FREQUENTATION.svg";
import PATRIMOINEsvg from "../../images/pictos-ok/PATRIMOINE.svg";
import { useStyles } from "../Theme.js";

import Breadcrumb from "../Breadcrumb";

const ChooseTheme = () => {
  let { url } = useRouteMatch();
  const history = useHistory();
  const classes = useStyles();
  const [destination, setDestination] = useState();

  /**
   * @Description Set le state destination à l'URL qu'il faudra rejoindre
   * @param {*} event
   */
  const handleNav = (event) => {
    setDestination(event.currentTarget.getAttribute("destination"));
    history.push(event.currentTarget.getAttribute("destination"));
  };

  /**
   * @Description Se rend à l'URL indiqué dans le state destination
   */
  const handleGo = (event) => {
    let destination = event.currentTarget.getAttribute("destination");
    console.log("rest");
    history.push(destination);
  };

  return (
    <Fragment>
      <Breadcrumb size={8} current={0} />
      <Box className={classes.subHeader} style={{ marginTop: 20 }}>
        <Typography variant="h3" className={classes.subHeaderTitle}>
          Votre theme
        </Typography>
        <Typography variant="body1" style={{ fontSize: 12 }}>
          Merci d'indiquer la thématique de votre observation. Ensuite, nous
          vous poserons plusieurs questions sur cette thématique (5 à 7
          questions par thème)
        </Typography>
      </Box>
      <Grid container spacing={2} style={{ maxWidth: "100%" }}>
        {/* Colonne de gauche */}
        <Grid item xs={6} className={classes.column}>
          <Button
            destination={`${url}/sentier`}
            className={classes.themeButton}
            onClick={handleGo}
            classes={{ label: "labelButton" }}
          >
            <img
              src={sentiersvg}
              alt="picto à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Sentier
          </Button>
          <Button
            destination={`${url}/frequentation`}
            className={classes.themeButton}
            onClick={handleGo}
            classes={{ label: "labelButton" }}
          >
            <img
              src={FREQUENTATIONsvg}
              alt="picto à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Fréquentation
          </Button>
          {/*<Link
            to={"/"}
            className={classes.gridLink}
            style={{ justifyContent: "flex-end", marginBottom: "3vh" }}
          >
            <Button className={classes.navButton}>
              <ArrowRightAltIcon style={{ transform: "rotate(0.5turn)" }} />
              Etape précédente
            </Button>
          </Link>*/}
        </Grid>
        {/* Colonne de droite */}
        <Grid
          item
          xs={6}
          className={classes.column}
          style={{ alignItems: "flex-start" }}
        >
          <Button
            destination={`${url}/services`}
            className={classes.themeButton}
            onClick={handleGo}
            classes={{ label: "labelButton" }}
          >
            <img
              src={SERVICES_PRO_DU_RANDONNEURsvg}
              alt="picto à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Services / commerces
          </Button>
          <Button
            destination={`${url}/patrimoine`}
            className={classes.themeButton}
            onClick={handleGo}
            classes={{ label: "labelButton" }}
          >
            <img
              src={PATRIMOINEsvg}
              alt="picto à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Patrimoine
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ChooseTheme;
